export default "__VITE_ASSET__7d3eb419__"